



























































































































































































import { Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";

import GlobalMixins from "@/global.mixin";
import AuditHistoryDetailDialog from "./AuditHistoryDetailDialog.vue";
import { AuditHistoryFilter } from "@/services/api/auditHistory.api";
import {importExportApi} from "../../services/api/importexport.api";

@Component({
  mixins: [GlobalMixins],
  components: {
    AuditHistoryDetailDialog
  }
})
export default class AuditHistory extends Vue {
  @State("auditHistory") auditHistories;
  @Action("getAuditHistories") getAuditHistories;

  filters: AuditHistoryFilter = {
    page: 1,
    rowsPerPage: 25,
    sortBy: "createdDate",
    descending: true,
    searchString: "",
    entityType: null,
    // entityId: -1,
    // fromDate: "",
    // toDate: "",
    // changedBy: "",
    action: null,
  };
  fromDateMenu = false;
  toDateMenu = false;
  detailDialog = false;
  selectedAuditHistory: any = null;
  exporting = false;

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "createdDate",
    descending: true,
    page: 1,
    rowsPerPage: this.$cookies.isKey("auditHistory-rowsPerPage") ?
                        parseInt(this.$cookies.get("auditHistory-rowsPerPage"), 10) : 25
  };

  actionOptions() { return[
        { text: "Minden művelet", value: null },
        { text: this.$t("AUDIT_HISTORY_ACTIONS_CREATED"), value: "Created" },
        { text: this.$t("AUDIT_HISTORY_ACTIONS_UPDATED"), value: "Updated" },
        { text: this.$t("AUDIT_HISTORY_ACTIONS_DELETED"), value: "Deleted" }
    ];
  }

  getEntityTypeOptions() { return[
        { text: this.$t("AUDIT_HISTORY_ALL_ENTITIES"), value: null },
        { text: this.$t("AUDIT_HISTORY_PRODUCTS"), value: "Product" },
        { text: this.$t("AUDIT_HISTORY_COST_CENTERS"), value: "CostCenter" },
        { text: this.$t("AUDIT_HISTORY_DEVICE_TYPES"), value: "DeviceType" },
        { text: this.$t("AUDIT_HISTORY_LOCATIONS"), value: "Location" },
        { text: this.$t("AUDIT_HISTORY_PRODUCT_STATES"), value: "ProductState" },
        { text: this.$t("AUDIT_HISTORY_SITES"), value: "Site" }
    ];
  }
  getHeaders() { return[
        { text: this.$t("AUDIT_HISTORY_TABLE_TIMESTAMP"), value: "createdDate", sortable: true, width: "1%" },
        { text: this.$t("AUDIT_HISTORY_TABLE_ENTITY_TYPE"), value: "entityType", sortable: true, width: "1%" },
        { text: this.$t("AUDIT_HISTORY_TABLE_ENTITY_NAME"), value: "entityName", sortable: true, width: "1%" },
        { text: this.$t("AUDIT_HISTORY_TABLE_ACTION"), value: "action", sortable: true, width: "1%" },
        { text: this.$t("AUDIT_HISTORY_TABLE_CHANGED_BY"), value: "changedBy", sortable: true, width: "1%" },
        { text: this.$t("AUDIT_HISTORY_TABLE_CHANGE_SUMMARY"), value: "changeSummary", sortable: false, width: "1%" },
        { text: this.$t("TABLE_ACTIONS"), value: "actions", sortable: false, width: "1%" },
        { text: "", value: "name", width: "1%", sortable: false, },
    ];
  }

  async created() {
    setTimeout(() => {
      // Your code here
      console.log("Executed after 300ms");
      this.loadAuditHistory();
    }, 300);
  }

  async loadAuditHistory() {

    const filters = Object.assign({}, this.filters);
    try {

      if (filters.toDate == null) {
        delete filters.toDate;
      }
      if (filters.fromDate == null) {
        delete filters.fromDate;
      }
      if (filters.entityType === "" || filters.entityType == null) {
        delete filters.entityType;
      }
      if (filters.action === "" || filters.action == null) {
        delete filters.action;
      }

      // console.log("filters: ", filters);
      await this.getAuditHistories(filters);
    } catch (error) {
      console.error("Error loading audit history:", error);
    }
  }

  updatePagination(pagination) {
      // console.log("updatePagination: ",);
    this.$cookies.set("auditHistory-rowsPerPage", pagination.rowsPerPage);

    const filters = Object.assign({}, this.filters);

    if (filters.toDate == null) {
      delete filters.toDate;
    }
    if (filters.fromDate == null) {
      delete filters.fromDate;
    }
    if (filters.entityType === "" || filters.entityType == null) {
      delete filters.entityType;
    }
    if (filters.action === "" || filters.action == null) {
      delete filters.action;
    }

    this.filters.page = pagination.page;
    this.filters.rowsPerPage = pagination.rowsPerPage;
    this.filters.sortBy = pagination.sortBy;
    this.filters.descending = pagination.descending;

    // console.log("filters: ", filters);
    this.getAuditHistories(filters);
  }

  async applyFilters() {
    await this.loadAuditHistory();
  }

  clearFilters() {
    this.filters = {
      page: 1,
      rowsPerPage: 25,
      sortBy: "createdDate",
      descending: true,
      searchString: "",
      entityType: null,
      // entityId: undefined,
      // fromDate: "",
      // toDate: "",
      // changedBy: "",
      action: null,
    };
    this.loadAuditHistory();
  }

  viewDetails(item: any) {
    this.selectedAuditHistory = item;
    this.detailDialog = true;
  }

  formatDate(dateString: string) {
    if (!dateString) {
      return "";
    }
    return new Date(dateString).toLocaleString();
  }

  getActionColor(action: string) {
    switch (action.toLowerCase()) {
      case "created": return "green";
      case "updated": return "blue";
      case "deleted": return "red";
      default: return "grey";
    }
  }

  getActionText(action: string) {
    switch (action.toLowerCase()) {
      case "created": return this.$t("AUDIT_HISTORY_ACTIONS_CREATED");
      case "updated": return this.$t("AUDIT_HISTORY_ACTIONS_UPDATED");
      case "deleted": return this.$t("AUDIT_HISTORY_ACTIONS_DELETED");
      default: return action;
    }
  }

  async exportToExcel() {
    this.exporting = true;


    const filters = Object.assign({}, this.filters);

    if (filters.toDate == null) {
      delete filters.toDate;
    }
    if (filters.fromDate == null) {
      delete filters.fromDate;
    }
    if (filters.entityType === "" || filters.entityType == null) {
      delete filters.entityType;
    }
    if (filters.action === "" || filters.action == null) {
      delete filters.action;
    }

    try {
      importExportApi.downloadAuditExport(filters, "audit-history-export.xlsx");
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    } finally {
      this.exporting = false;
    }
  }
}
